import auth0 from "auth0-js";
import Vue from "vue";
var config = require("../config");

let appAuthRedirectURI =
  process.env.NODE_ENV === "production" ? config.build.appAuthRedirectURI : config.dev.appAuthRedirectURI;
// exchange the object with your own from the setup step above.
let webAuth = new auth0.WebAuth({
  domain: "varivac.auth0.com",
  clientID: "jh64aDSRzSQjo3rEwC0CudAp0H32E4LP",
  redirectUri: appAuthRedirectURI,
  audience: "https://varivac.auth0.com/api/v2/",
  responseType: "token id_token",
  scope: "openid profile email"
});

let auth = new Vue({
  computed: {
    token: {
      get: function() {
        return localStorage.getItem("id_token");
      },
      set: function(id_token) {
        localStorage.setItem("id_token", id_token);
      }
    },
    accessToken: {
      get: function() {
        return localStorage.getItem("access_token");
      },
      set: function(accessToken) {
        localStorage.setItem("access_token", accessToken);
      }
    },
    expiresAt: {
      get: function() {
        return localStorage.getItem("expires_at");
      },
      set: function(expiresIn) {
        let expiresAt = JSON.stringify(expiresIn * 1000 + new Date().getTime());
        localStorage.setItem("expires_at", expiresAt);
      }
    },
    user: {
      get: function() {
        return JSON.parse(localStorage.getItem("user"));
      },
      set: function(user) {
        localStorage.setItem("user", JSON.stringify(user));
      }
    }
  },
  methods: {
    login() {
      webAuth.authorize({
        audience: "https://variablevac.com/"
      });
    },
    logout() {
      this.$session.destroy();
      webAuth.logout({
        clientID: webAuth.baseOptions.clientID,
        returnTo: "https://www.variablevac.com/",
        federated: true
      });
      localStorage.removeItem("access_token");
      localStorage.removeItem("id_token");
      localStorage.removeItem("expires_at");
      localStorage.removeItem("user");
    },
    isAuthenticated() {
      return new Date().getTime() < this.expiresAt;
    },
    handleAuthentication() {
      return new Promise((resolve, reject) => {
        webAuth.parseHash((err, authResult) => {
          if (authResult && authResult.accessToken && authResult.idToken) {
            this.expiresAt = authResult.expiresIn;
            this.accessToken = authResult.accessToken;
            this.token = authResult.idToken;
            this.user = authResult.idTokenPayload;
            resolve();
          } else if (err) {
            this.logout();
            reject(err);
          }
        });
      });
    }
  }
});

export default {
  install: function(Vue) {
    Vue.prototype.$auth = auth;
  }
};



// WEBPACK FOOTER //
// ./src/auth.js